<template>
  <li class="nav-item parent">
    <SidebarLink
      :item="item"
      :empty="children.length > 0"
      @open="isOpen = !isOpen"
      :class="{ open: isOpen }"
    />
    <Transition name="accordion">
      <ul
        class="list-unstyled"
        v-show="children.length && isOpen"
      >
        <li
          v-for="child in children"
          :key="child.id"
          class="children"
        >
          <SidebarLink :item="child" />
        </li>
      </ul>
    </Transition>
  </li>
</template>

<script setup>
import { computed, shallowRef } from 'vue'
import SidebarLink from '@/components/sidebar/sidebarLink.vue'
import { useUserStore } from '@/stores/user.js'

const props = defineProps({
  item: {
    type: Object,
    default: () => {},
  },
})
const isOpen = shallowRef(false)
const userStore = useUserStore()
const children = computed(
  () =>
    (props.item?.children || []).filter(
      lnk => lnk.meta?.sidebar === true && userStore.can(lnk.meta?.rbac)
    ) || []
)
</script>
